import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    permissioningCache: null,
    pendingDomains: [],
};
const permissioningSlice = createSlice({
    name: 'permissioning',
    initialState,
    reducers: {
        setPermissioningCache: (state, action) => {
            const { domain, resources } = action.payload;
            state.permissioningCache = {
                ...state.permissioningCache,
                [domain]: resources,
            };
        },
        clearPermissioningCache: state => {
            state.permissioningCache = null;
        },
        addPendingDomain: (state, action) => {
            const { domain } = action.payload;
            if (!state.pendingDomains.includes(domain)) {
                state.pendingDomains = [...state.pendingDomains, domain];
            }
        },
        removePendingDomain: (state, action) => {
            const { domain } = action.payload;
            state.pendingDomains = state.pendingDomains.filter((pendingDomain) => pendingDomain !== domain);
        },
        clearPendingDomains: state => {
            state.pendingDomains = [];
        },
    },
});
export const { setPermissioningCache, clearPermissioningCache, addPendingDomain, removePendingDomain, clearPendingDomains, } = permissioningSlice.actions;
export default permissioningSlice.reducer;
